import { useState, useRef, useEffect } from "react";
import "./DashboardBox.css";
import { Col, Row } from "react-bootstrap";
import { toast } from 'react-toastify';
import {
  get_fund_invoices,
  get_single_beneficiary_reimbursement,
  getAccomulateDeduction,
  getMonthUtilization,
  getReconcilation,
} from "../../helper/Api";
import Accordion from "react-bootstrap/Accordion";
import moment from "moment";
import { useSelector } from "react-redux";
import BankBalanceOverlay from "../overlays/BankBalanceOverlay";
import SchemeBudgetOverlay from "../overlays/SchemeBudgetOverlay";
import SchemeBalance from "../overlays/SchemeBalance";
import UtilizedBudgetOverlay from "../overlays/UtilizedBudgetOverlay";
import ApprovalOverlay from "../overlays/ApprovalOverlay";
import DashboardFilter from "../../pages/Dashboard/components/DashboardFilter";
import ReconciliationOverlay from "./DashboardComponents/ReconcilationOverlay";


const DashboardBox = ({ data, openFilterModal, dividerNumber, fy_list, handleYearDropdown, filterPayload, handleFilterRemove }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isUtilized, setUtilized] = useState(false);
  const [schemaBalance, setSchemaBalance] = useState(false);
  const [approvals, setApprovals] = useState(false);
  const [utlizedBudget, setUtilizedBudget] = useState(false);
  const contentRef = useRef(null);
  const contentRefUtlized = useRef(null);
  const schemaBalanceRef = useRef(null);
  const approvalRef = useRef(null);
  const [overlay, setOverlay] = useState(true);
  const [schemebalance, setSchemebalance] = useState(true);
  const [budgetoverlay, setbudgetoverlay] = useState(true);
  const [bankBalanceOverlay, setBankBalanceOverlay] = useState(true);
  const [overlayDropDown, setOverlayDropDown] = useState(false);
  const [approvalsOverlay, setApprovalsOverlay] = useState(false);
  const [accumulatedDeductionOverlay, setAccumulatedDeductionOverlay] = useState(false);
  const [reconciliationOverlay, setReconciliationOverlay] = useState(false);
  const [utlizedMonthCard, setUtilizedMonthCard] = useState(null);
  const storedGlobalDateId = localStorage.getItem("globalDateId");
  const { authData } = useSelector((state) => state.authData);
  const [subheadAccording, setSubheadAccording] = useState({});
  const [subheadAccordingdbtAcd, setSubheadAccordingdbtAcd] = useState({});
  const toggleAccordionacd = (index) => {
    setSubheadAccordingdbtAcd((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle specific accordion
    }));
  };
  const [invoices, setInvoice] = useState([]);
  // Toggle function
  // ==========================================bank balance overlayData=================================================
  const [bankBalanceData, setBankBalanceData] = useState([]);
  const fetchBankBalance = (data) => {
    setBankBalanceData(data);
  };
  const totalAccountBalance = bankBalanceData.reduce((acc, val) => {
    return acc + Number(val.account_balance);
  }, 0);
  // const totalQuartlyInterest = bankBalanceData?.reduce((acc, val) => {
  //   return acc + Number(val?.interest);
  // }, 0);
  // =========================total Budget Allocation=======================

  const getMonthlUtilizationHandler = async (month) => {
    setUtilizedMonthCard(month);
    await get_monthly_utilization(storedGlobalDateId, month, authData.user.department_id);
  }

  const get_monthly_utilization = async (fyId, monthId, department_id) => {
    try {
      const { data } = await getMonthUtilization(fyId, monthId, department_id);
      setMonthData(data);
    } catch (err) {
      toast.error("Something Went Wrong", {
            position: toast.POSITION.TOP_CENTER
          });
    }
  };
  // ============================ reconciliation ============================

  const [accumulatedDeduction, setAccumulatedDeductoin] = useState([]);
  const [accumulatedDeductionDbt, setAccumulatedDeductoinDbt] = useState([]);
  const totalReimbursementOrderValue = accumulatedDeductionDbt?.reduce(
    (acc, val) => acc + Number(val?.reimbursement_order_value || 0),
    0
  );

  const totalTdsIts = accumulatedDeduction?.reduce(
    (sum, val) => sum + Number(val?.tds_it_amount || 0),
    0
  );
  const totalGst = accumulatedDeduction?.reduce(
    (sum, val) =>
      sum +
      Number(val?.c_gst_amount || 0) +
      Number(val?.i_gst_amount || 0) +
      Number(val?.s_gst_amount || 0),
    0
  );
  const totalRoyaltys = accumulatedDeduction?.reduce(
    (sum, val) => sum + Number(val?.royalty_amount || 0),
    0
  );
  const totalLabour = accumulatedDeduction?.reduce(
    (sum, val) => sum + Number(val?.labour_amount || 0),
    0
  );
  const totalOtherDeduction = accumulatedDeduction?.reduce(
    (sum, val) => sum + Number(val?.other_deduction || 0),
    0
  );
  const totalOverallAccDeduction =
    totalTdsIts + totalGst + totalRoyaltys + totalLabour + totalOtherDeduction;

  const [settlementsInProgress, setSettlementsInProgress] = useState([]);
  const [withHeldAndPenalty, setWithHeldAndPenalty] = useState([]);

  const totalWithheld = withHeldAndPenalty?.reduce(
    (sum, val) => sum + Number(val?.withheld_amount || 0),
    0
  );
  const totalPenalty = withHeldAndPenalty?.reduce(
    (sum, val) => sum + Number(val?.penalty_amount || 0),
    0
  );
  const totalOverall = totalWithheld + totalPenalty;

  const fetchgetReconcilation = async (id) => {
    try {
      const res = await getReconcilation({fyId: id, department_id: filterPayload.department_id || authData.user.department_id});
      setAccumulatedDeductoin(res?.data?.result?.accumulatedDeduction?.vendor);
      setAccumulatedDeductoinDbt(res?.data?.result?.accumulatedDeduction?.DBT);
      setSettlementsInProgress(
        res?.data?.result?.settlementsInProgress?.vendor
      );
      setWithHeldAndPenalty(res?.data?.result?.withHeldAndPenalty?.vendor);
    } catch (err) {
      console.log(err.message);
    }
  };

  const formatNumber = (number, style = "international") => {
    number = parseFloat(number).toFixed(2); // Ensure input is a float with two decimal places

    if (style === "indian") {
      return number.replace(/\B(?=(\d{3})(\d{2})*(?!\d))/g, ",");
    } else {
      return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };

  const addElipsis = (str, limit) =>
    typeof str === "string" && str.length > limit
      ? str.slice(0, limit) + "..."
      : str || "-";

  const fetchInvoices = async () => {
    try {
      const invoices_response = await get_fund_invoices({
        user_type: authData?.user?.user_type?.toUpperCase() || "L1",
        from_date: null || "",
        to_date: null || "",
        dateColumn: null || "",
        search_str: null || "",
        isAll: false,
        department_id: filterPayload.department_id || authData.user.department_id,
      });
      if (invoices_response.data.status) {
        const approvedInvoicesdata = invoices_response.data.list.filter(
          (val) => val?.approval_status != 2 && val?.l3_approval_status != 2
        );
        setInvoice(approvedInvoicesdata);
      } else {
        toast.error(invoices_response.data?.message || "Failed to fetch invoices", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error(error?.message || "Something Went Wrong", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  const [accumulateHeight, setAccumulatedHeight] = useState(false);
  const [reconHeight, setReconHeight] = useState(false);

  const toggleExpand = (value) => {
    if (value === "schemeBudget") {
      setIsExpanded((prev) => !prev);
    } else if (value === "utilizedBudget") {
      setUtilized((prev) => !prev);
    } else if (value === "schemaBalance") {
      setSchemaBalance((prev) => !prev);
    } else if (value === "utlizedBudgetn") {
      setUtilizedBudget((prev) => !prev);
    } else if (value === "approvals") {
      setApprovals((prev) => !prev);
    } else if (value === "accumulated") {
      setAccumulatedHeight((prev) => !prev);
    } else if (value === "recon") {
      setReconHeight((prev) => !prev);
    }
  };

  const openBankBalanceOverlay = (value) => {
    setBankBalanceOverlay(value);
  };
  // =========================responsivetable data ======================
  const [activeKeys, setActiveKeys] = useState([]); // Initially open accordions
  const toggleAccordion = (key) => {
    setActiveKeys(
      (prevKeys) =>
        prevKeys.includes(key)
          ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
          : [...prevKeys, key] // Add key if it's closed
    );
  };
  const [accumulationVendorData, setAccumulationVendorData] = useState([]);
  const [accumulationDBTData, setAccumulationDBTVendorData] = useState([]);

  const totalDeductions = accumulationDBTData?.reduce(
    (acc, item) => acc + Number(item.deduction_amount),
    0
  );
  const totalGrossAmount = accumulationDBTData?.reduce(
    (acc, item) => acc + Number(item.reimbursement_order_value),
    0
  );

  // =============total data for accumulated vendor==================

  const accDedutionTdsItReduct = accumulationVendorData?.map(
    (val, ind) => val.tds_it_amount
  );
  const accDedutionRoyaltyAmountReduct = accumulationVendorData?.map(
    (val, ind) => val.royalty_amount
  );
  const acclaboutCess = accumulationVendorData?.map(
    (val, ind) => val.labour_amount
  );
  const accOther = accumulationVendorData?.map((val, ind) =>
    val.other_deduction == null ? 0 : val?.other_deduction
  );

  const accTotalTdsGst = accumulationVendorData?.map(
    (val, ind) =>
      Number(val?.c_gst_amount) +
      Number(val?.i_gst_amount) +
      Number(val?.s_gst_amount)
  );

  const totalTdsIt = accDedutionTdsItReduct?.reduce(
    (sum, num) => sum + Number(num),
    0
  );
  const totalRoyalty = accDedutionRoyaltyAmountReduct?.reduce(
    (sum, num) => sum + Number(num),
    0
  );
  const totalacclaboutCess = acclaboutCess?.reduce(
    (sum, num) => sum + Number(num),
    0
  );
  const totalaccOther = accOther?.reduce((sum, num) => sum + Number(num), 0);
  const totalaccTotalTdsGst = accTotalTdsGst?.reduce(
    (sum, num) => sum + Number(num),
    0
  );

  const getAccomulateDeductions = async (fyId) => {
    try {
      const getAccomulate = await getAccomulateDeduction({fyId, department_id: filterPayload.department_id || authData.user.department_id});
      if (getAccomulate.data.status) {
        setAccumulationVendorData(getAccomulate.data.result[0]);
        setAccumulationDBTVendorData(getAccomulate.data.result[1]);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch accumulated deductions",
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
    }
  };

  const [singleBeneficiarys, setSingleBeneficiarys] = useState([]);
  const getSingleBeneficiaryReimbursements = async (id) => {
    try {
      const { data } = await get_single_beneficiary_reimbursement(id);
      setSingleBeneficiarys(data.result.beneficiaries);
    } catch (err) {
      toast.error(err?.message || "Something Went Wrong", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  const [monthData, setMonthData] = useState({});

  useEffect(() => {
    fetchInvoices();
    setOverlay(true);
    setApprovalsOverlay(true);
    setAccumulatedDeductionOverlay(true);
    setReconciliationOverlay(true);
    
  }, [filterPayload.department_id]);


  // const fetchSchemeBudget = async (id , departmentId) => {
  //   try{
  //     const {data} = await getSchemeBudget(id , departmentId);
  //     setSchemesList(data.result);
  //   }catch(err){
  //     console.log(err.name);
  //   }
  // }


  useEffect(() => {
    fetchgetReconcilation(storedGlobalDateId);
    getAccomulateDeductions(storedGlobalDateId);
  }, [storedGlobalDateId, filterPayload.department_id]);

  return (
    <>
      <div className=" row p-3 overflow-x-hidden">
        <div className="col-9">
      <DashboardFilter openFilterModal={openFilterModal} filterPayload={filterPayload} handleFilterRemove={handleFilterRemove}></DashboardFilter>
      
          <Row>
            <Col xs={12} sm={6} md={6} lg={4}>
              <div className="dashboardStatCard ">
                <h3
                  className="bg-prime-100 text-white p-2 m-0 d-flex justify-content-between align-items-center"
                  style={{ borderRadius: "10px 10px 0 0" }}
                >
                  Scheme Budget
                  <i
                    className="icon-open_in_new cursor-pointer transition-3s hover-scale-1-2"
                    onClick={() => setOverlay(false)}
                  ></i>
                </h3>

                <div
                  ref={contentRef}
                  className={`add-transition  ${isExpanded ? "p-2" : "p-0"}`}
                  style={{
                    height: isExpanded
                      ? `${contentRef.current.scrollHeight}px`
                      : "0px ",
                    overflow: "hidden",
                    transition: "height 0.3s ease",
                  }}
                >
                  <h6 className="text-black-60 fs-12px">Provisioned Budget</h6>
                  <p className="fw-600">
                    {formatNumber(
                      Number(data.total_provisional_budget.provisional_budget),
                      "indian"
                    )}
                  </p>
                  <h6 className="text-black-60 fs-12px">Released Budget</h6>
                  <p className="fw-600">
                    {formatNumber(
                      Number(data.total_provisional_budget.released_budget),
                      "indian"
                    )}
                  </p>
                  <h6 className="text-black-60 fs-12px">Prev. Year Balance</h6>
                  <p className="fw-600">
                    {formatNumber(Number(data.prevYearBalance), "indian")}
                  </p>
                </div>

                <div className="p-2 border-top d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="fs-12px">Total Budget</h4>
                    <h4 style={{ fontSize: "16px", fontWeight: "600" }}>
                      {formatNumber(
                        (Number(data.prevYearBalance) +
                          Number(
                            data.total_provisional_budget.released_budget
                          )) /
                          dividerNumber,
                        "indian"
                      )}
                    </h4>
                  </div>
                  <div>
                    {!isExpanded ? (
                      <i
                        className="icon-add_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("schemeBudget")}
                      ></i>
                    ) : (
                      <i
                        className="icon-remove_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("schemeBudget")}
                      ></i>
                    )}
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} sm={6} md={6} lg={4}>
              <div className="dashboardStatCard">
                <h3
                  className="bg-prime-100 text-white p-2 m-0 d-flex justify-content-between align-items-center"
                  style={{ borderRadius: "10px 10px 0 0" }}
                >
                  Utilized Budget
                  <i
                    className="icon-open_in_new cursor-pointer transition-3s hover-scale-1-2"
                    onClick={() => setbudgetoverlay(false)}
                  ></i>
                </h3>

                <div
                  ref={contentRefUtlized}
                  className={`add-transition  ${isUtilized ? "p-2" : "p-0"}`}
                  style={{
                    height: isUtilized
                      ? `${contentRefUtlized.current.scrollHeight}px`
                      : "0px ",
                    overflow: "hidden",
                    transition: "height 0.3s ease",
                  }}
                >
                  <h6 className="text-black-60 fs-12px">
                    Current FY {
                        fy_list?.map((val , ind)=>{
                          return val?.id == storedGlobalDateId && val?.year
                        })
                      }
                  </h6>
                  <p className="fw-600">
                    {formatNumber(Number(data.currenyFyUtilization) + Number(data?.sanctioned_amount), "indian")}
                  </p>
                  <h6 className="text-black-60 fs-12px">Prev. Year Balance</h6>
                  <p className="fw-600">
                    {data.prevFyUtilization == 0
                      ? "-"
                      : formatNumber(Number(data.prevFyUtilization), "indian")}
                  </p>
                  <span
                    className="fw-600 py-2 d-flex justify-content-between"
                    style={{ fontSize: "16px" }}
                  >
                    For Month
                    <select
                      name="month"
                      id="month"
                      className="border-0 overflow-auto text-prime-100"
                      onChange={(e) => getMonthlUtilizationHandler(e.target.value)}
                      defaultValue={utlizedMonthCard}
                    >
                      <option value="" selected>
                        select month
                      </option>
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                  </span>
                  <h6 className="text-black-60 mt-2 fs-12px">
                    Current FY {
                        fy_list?.map((val , ind)=>{
                          return val?.id == storedGlobalDateId && val?.year
                        })
                      }
                  </h6>
                  <p className="fw-600">
                    {(monthData?.currentMonthUtilize_cfy || 0) == 0
                      ? "-"
                      : formatNumber(
                          Number(monthData?.currentMonthUtilize_cfy),
                          "indian"
                        )}
                  </p>
                  <h6 className="text-black-60 fs-12px">Prev. Year Balance</h6>
                  <p className="fw-600">
                    {(monthData?.currentMonthUtilize_pfy || 0) == 0
                      ? "-"
                      : formatNumber(
                          Number(monthData?.currentMonthUtilize_pfy),
                          "indian"
                        )}
                  </p>
                </div>

                <div className="p-2 border-top d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="fs-12px">FY {
                        fy_list?.map((val , ind)=>{
                          return val?.id == storedGlobalDateId && val?.year
                        })
                      } Utilized</h4>
                    <h4 style={{ fontSize: "16px", fontWeight: "600" }}>
                      {formatNumber(
                        Number(
                          Number(data.currenyFyUtilization) + Number(data?.sanctioned_amount) + data.prevFyUtilization
                        ) / dividerNumber,
                        "indian"
                      )}
                    </h4>
                  </div>
                  <div>
                    {!isUtilized ? (
                      <i
                        className="icon-add_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("utilizedBudget")}
                      ></i>
                    ) : (
                      <i
                        className="icon-remove_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("utilizedBudget")}
                      ></i>
                    )}
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} sm={6} md={6} lg={4}>
              <div className="dashboardStatCard">
                <h3
                  className="bg-prime-100 text-white p-2 m-0 d-flex justify-content-between align-items-center"
                  style={{ borderRadius: "10px 10px 0 0" }}
                >
                  Scheme Balance
                  <i
                    className="icon-open_in_new cursor-pointer transition-3s hover-scale-1-2"
                    onClick={() => setSchemebalance(false)}
                  ></i>
                </h3>

                <div
                  ref={schemaBalanceRef}
                  className={`add-transition  ${schemaBalance ? "p-2" : "p-0"}`}
                  style={{
                    height: schemaBalance
                      ? `${contentRefUtlized.current.scrollHeight}px`
                      : "0px ",
                    overflow: "hidden",
                    transition: "height 0.3s ease",
                  }}
                >
                  <h6 className="text-black-60 fs-12px">
                    Surrender Budget Fy {
                        fy_list?.map((val , ind)=>{
                          return val?.id == storedGlobalDateId && val?.year
                        })
                      }
                  </h6>
                  <p className="fw-600">
                    { formatNumber(Number(data.curr_surrender.approved_surrender) + Number(data.curr_surrender.pending_surrender), "indian") }
                  </p>
                  <h6 className="text-black-60 fs-12px">
                    Current Fy {
                        fy_list?.map((val , ind)=>{
                          return val?.id == storedGlobalDateId && val?.year
                        })
                      }
                  </h6>
                  <p className="fw-600">
                    { formatNumber(data.total_provisional_budget.released_budget - (data.currenyFyUtilization + Number(data?.sanctioned_amount) + Number(data.curr_surrender.approved_surrender) + Number(data.curr_surrender.pending_surrender)), "indian") }
                  </p>
                  <h6 className="text-black-60 fs-12px">
                    From Prev. Year Balance
                  </h6>
                  <p className="fw-600">
                    {formatNumber(
                      Number(data.prevYearBalance - data.prevFyUtilization),
                      "indian"
                    )}
                  </p>
                </div>

                <div className="p-2 border-top d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="fs-12px">Total Balance</h4>
                    <h4 style={{ fontSize: "16px", fontWeight: "600" }}>
                      {formatNumber(
                        ((Number(data.prevYearBalance) + (data.total_provisional_budget.released_budget - (data.currenyFyUtilization + Number(data?.sanctioned_amount) + Number(data.curr_surrender.approved_surrender) + Number(data.curr_surrender.pending_surrender)))) -
                          Number(
                            data.prevFyUtilization
                          )) /
                          dividerNumber,
                        "indian"
                      )}
                    </h4>
                  </div>
                  <div>
                    {!schemaBalance ? (
                      <i
                        className="icon-add_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("schemaBalance")}
                      ></i>
                    ) : (
                      <i
                        className="icon-remove_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("schemaBalance")}
                      ></i>
                    )}
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} sm={6} md={6} lg={4}>
              <div className="dashboardStatCard">
                <h3
                  className="bg-prime-20 p-2 m-0 d-flex justify-content-between align-items-center"
                  style={{ borderRadius: "10px 10px 0 0" }}
                >
                  Approvals
                  <i
                    className="icon-open_in_new cursor-pointer transition-3s hover-scale-1-2"
                    onClick={() => setApprovalsOverlay(false)}
                  ></i>
                </h3>

                <div
                  ref={approvalRef}
                  className={`add-transition ${approvals ? "p-2" : "p-0"}`}
                  style={{
                    height: approvals
                      ? `398px`
                      : "0px ",
                    overflow: "hidden",
                    transition: "height 0.3s ease",
                  }}
                >
                  <h6 className="text-black-60 fs-12px p-0 my-1">
                    <span>{data?.stats[0]?.invoice_pending_count + " "}</span>
                    Vendor Invoice for Approval
                  </h6>
                  <p className="fw-600 p-0 m-0 mb-1">
                    {formatNumber(Number(data?.sanctioned_amount), "indian")}
                  </p>
                  <h6 className="text-black-60 fs-12px ">
                    {data?.stats[0]?.invoice_payment_pending_count + " "}
                    Vendor Invoice for payment
                  </h6>
                  <p className="fw-600 ">
                    {data?.payable_expanses > 0
                      ? formatNumber(data?.payable_expanses, "indian")
                      : "-"}
                  </p>
                  <h6 className="text-black-60 fs-12px">
                    {data?.stats[0]?.dbt_pending_approval_count + " "}
                    DBT/Nach for Approval
                  </h6>
                  <p className="fw-600">
                    {data?.reimbursement_details[0]?.under_approval > 0
                      ? formatNumber(
                          data?.reimbursement_details[0]?.under_approval,
                          "indian"
                        )
                      : "-"}
                  </p>
                  <h6 className="text-black-60 fs-12px">
                    {data?.stats[0]?.dbt_pending_payment_approval + " "}
                    DBT/Nach for Payment
                  </h6>
                  <p className="fw-600">
                    {data?.reimbursement_details[1]?.payment_approval > 0
                      ? formatNumber(
                          data?.reimbursement_details[1]?.payment_approval,
                          "indian"
                        )
                      : "-"}
                  </p>
                  <h6 className="text-black-60 fs-12px">
                    {data?.stats[0]?.salary_pending_approval + " "}
                    Salary for Approval
                  </h6>
                  <p className="fw-600">
                    {data?.salary_details[0]?.under_approval > 0
                      ? formatNumber(
                          data?.salary_details[0]?.under_approval,
                          "indian"
                        )
                      : "-"}
                  </p>
                  <h6 className="text-black-60 fs-12px">
                    {data?.stats[0]?.salary_pending_payment_approval + " "}
                    Salary for Payment
                  </h6>
                  <p className="fw-600">
                    {data?.salary_details[1]?.payment_approval > 0
                      ? formatNumber(
                          data?.salary_details[1]?.payment_approval,
                          "indian"
                        )
                      : "-"}
                  </p>
                  <h6 className="text-black-60 fs-12px">
                    {data?.stats[0]?.budget_allocation_pending_count + " "}
                    Budget Allocatoin for Approval
                  </h6>
                  <p className="fw-600">
                    {data?.pending_budget_allocation > 0
                      ? formatNumber(data?.pending_budget_allocation, "indian")
                      : "-"}
                  </p>
                </div>
                <div className="p-2 border-top d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="fs-12px">Total Approval & Payment</h4>
                    <h4 style={{ fontSize: "16px", fontWeight: "600" }}>
                      {formatNumber(
                        (Number(data.sanctioned_amount) +
                          Number(data?.payable_expanses) +
                          Number(
                            data?.reimbursement_details[0]?.under_approval
                          ) +
                          Number(
                            data?.reimbursement_details[1]?.payment_approval
                          ) +
                          Number(
                            data?.salary_details[0]?.under_approval
                          ) +
                          Number(
                            data?.salary_details[1]?.payment_approval
                          ) +
                          Number(data?.pending_budget_allocation)) /
                          dividerNumber,
                        "indian"
                      )}
                    </h4>
                  </div>
                  <div>
                    {!approvals ? (
                      <i
                        className="icon-add_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("approvals")}
                      ></i>
                    ) : (
                      <i
                        className="icon-remove_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("approvals")}
                      ></i>
                    )}
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} sm={6} md={6} lg={4}>
              <div className="dashboardStatCard">
                <h3
                  className="bg-prime-20 p-2 m-0 d-flex justify-content-between align-items-center"
                  style={{ borderRadius: "10px 10px 0 0" }}
                >
                  Accumulated Deduction
                  <i
                    className="icon-open_in_new cursor-pointer transition-3s hover-scale-1-2"
                    onClick={() => setAccumulatedDeductionOverlay(false)}
                  ></i>
                </h3>

                <div
                  ref={approvalRef}
                  className={`add-transition  ${
                    accumulateHeight ? "p-2" : "p-0"
                  }`}
                  style={{
                    height: accumulateHeight
                      ? `${contentRef.current.scrollHeight}px`
                      : "0px ",
                    overflow: "hidden",
                    transition: "height 0.3s ease",
                  }}
                >
                  <h6 className="text-black-60 fs-12px">Total Vendor</h6>
                  <p className="fw-600">
                    {formatNumber(Number(data?.accumulated?.vendor), "indian")}
                  </p>
                  <h6 className="text-black-60 fs-12px">Total DBT/NACH</h6>
                  <p className="fw-600">
                    {formatNumber(data?.accumulated?.dbt, "indian")}
                  </p>
                  <h6 className="text-black-60 fs-12px">Total Salary</h6>
                  <p className="fw-600">
                    {formatNumber(data?.accumulated?.salary, "indian")}
                  </p>
                </div>
                <div className="p-2 border-top d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="fs-12px">Total Deduction</h4>
                    <h4 style={{ fontSize: "16px", fontWeight: "600" }}>
                      {formatNumber(
                        (Number(data?.accumulated?.vendor) +
                          Number(data?.accumulated?.dbt) +
                          Number(data?.accumulated?.salary)) /
                          Number(dividerNumber) || "-",
                        "indian"
                      )}
                    </h4>
                  </div>
                  <div>
                    {!accumulateHeight ? (
                      <i
                        className="icon-add_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("accumulated")}
                      ></i>
                    ) : (
                      <i
                        className="icon-remove_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("accumulated")}
                      ></i>
                    )}
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} sm={6} md={6} lg={4}>
              <div className="dashboardStatCard">
                <h3
                  className="bg-prime-20 p-2 m-0 d-flex justify-content-between align-items-center"
                  style={{ borderRadius: "10px 10px 0 0" }}
                >
                  Reconciliation
                  <i
                    className="icon-open_in_new cursor-pointer transition-3s hover-scale-1-2"
                    onClick={() => setReconciliationOverlay(false)}
                  ></i>
                </h3>

                <div
                  ref={approvalRef}
                  className={`add-transition  ${reconHeight ? "p-2" : "p-0"}`}
                  style={{
                    height: reconHeight
                      ? `${contentRef.current.scrollHeight}px`
                      : "0px ",
                    overflow: "hidden",
                    transition: "height 0.3s ease",
                  }}
                >
                  <h6 className="text-black-60 fs-12px">Total Accumulated</h6>
                  <p className="fw-600">
                    {formatNumber(
                      (totalReimbursementOrderValue +
                        totalOverallAccDeduction) /
                        dividerNumber,
                      "indian"
                    )}
                  </p>
                  <h6 className="text-black-60 fs-12px">
                    Total Settlements In Progress
                  </h6>
                  <p className="fw-600">-</p>
                  <h6 className="text-black-60 fs-12px">
                    Total With held and penalty
                  </h6>
                  <p className="fw-600">
                    {totalOverall == 0
                      ? "-"
                      : formatNumber(totalOverall / dividerNumber, "india")}
                  </p>
                </div>
                <div className="p-2 border-top d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="fs-12px">Total Reconciliation</h4>
                    <h4 style={{ fontSize: "16px", fontWeight: "600" }}>
                      {formatNumber(
                        (totalReimbursementOrderValue +
                          totalOverallAccDeduction +
                          totalOverall) /
                          dividerNumber,
                        "indian"
                      )}
                    </h4>
                  </div>
                  <div>
                    {!reconHeight ? (
                      <i
                        className="icon-add_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("recon")}
                      ></i>
                    ) : (
                      <i
                        className="icon-remove_circle_outline cursor-pointer"
                        onClick={() => toggleExpand("recon")}
                      ></i>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* ===============================right side bar ================================= */}

        <div className=" col-3">
          <Col sm={12}>
            <div className="dashboardStatCard">
              <h3
                className="bg-success-100 fs-20px text-white px-2 py-3 m-0 d-flex justify-content-between align-items-center"
                style={{ borderRadius: "10px 10px 0 0" }}
              >
                <span className="d-flex flex-column gap-1 fs-12px">
                  Total Bank Balance
                  <span style={{ fontSize: "20px" }}>
                    {formatNumber(totalAccountBalance, "indian")}
                  </span>
                </span>
                <i
                  className="icon-more_vert cursor-pointer"
                  onClick={() => openBankBalanceOverlay(false)}
                ></i>
              </h3>

              <div>
                <div className="hover-bg-prime-20 p-2 transition ">
                  <h6 className="text-black-60 fs-12px">
                    Current FY Interest Earn
                  </h6>

                  <div className="d-flex justify-content-between align-items-center">
                    <div className="fw-600">
                          {
                            bankBalanceData[0]?.quarterlyInterest?.reduce((acc, val) => {
                              return acc + Number(val.amount);
                            }, 0)
                          }
                    </div>
                  </div>
                </div>

                {bankBalanceData[0]?.quarterlyInterest?.map((val, ind) => (
                  <div className="hover-bg-prime-20 p-2 transition" key={ind}>
                    <h6 className="text-black-60 fs-12px">
                      Accured Interest Q{val?.quarter}
                    </h6>

                    <div className="d-flex justify-content-between align-items-center">
                      <div className="fw-600">
                        {Number(val?.amount) == 0
                          ? "-"
                          : formatNumber(
                              Number(val?.amount) / dividerNumber,
                              "indian"
                            )}
                      </div>
                    </div>
                  </div>
                ))}

                {/* ==============action btn=========== */}
                <div className="d-flex">
                  <div className="row fs-12px px-1 pb-1 m-0 gap-2 d-flex flex-column w-25">
                    {bankBalanceData?.map(
                      (val, bbInd) =>
                        val?.l2_approval == null && (
                          <button className="fs-12px border-0 rounded-1 px-2 py-1 d-flex gap-1 align-items-center bg-danger-20" key={bbInd}>
                            <span className="d-flex align-items-center justify-content-between gap-1 w-100">
                              <span>l2</span>
                              <i className="icon-close_circle_stroke fs-14px m-0 p-0 text-danger-100"></i>
                            </span>
                          </button>
                        )
                    )}
                  </div>
                  <div className="row fs-12px px-1 pb-1 m-0 gap-2 d-flex flex-column w-25">
                    {bankBalanceData?.map(
                      (val, bbInd) =>
                        val?.l3_approval == null && (
                          <button className="fs-12px border-0 rounded-1 px-2 py-1 d-flex gap-1 align-items-center bg-danger-20" key={bbInd}>
                            <span className="d-flex align-items-center justify-content-between gap-1 w-100">
                              l3
                              <i className="icon-close_circle_stroke fs-14px m-0 p-0 text-danger-100"></i>
                            </span>
                          </button>
                        )
                    )}
                  </div>
                </div>
                {bankBalanceData?.map(
                  (val, bbInd) =>
                    val?.l3_approval == null &&
                    val?.l2_approval == null && (
                      <div className="d-flex px-1" key={bbInd}>
                        <span className="fs-12px text-black-50">
                          {val?.account_no}
                        </span>
                      </div>
                    )
                )}
              </div>
            </div>
          </Col>
        </div>
      </div>

      {/* =====================scheme budget overlay========================== */}

      <SchemeBudgetOverlay 
        overlay={overlay} 
        setOverlay={setOverlay} 
        dividerNumber={dividerNumber} 
        addElipsis={addElipsis} 
        fy_list={fy_list} 
        filterPayload={filterPayload}
      />

      {/* =====================utilized budget overlay========================== */}

     <UtilizedBudgetOverlay 
     budgetoverlay={budgetoverlay} 
     dividerNumber={dividerNumber}  
     addElipsis={addElipsis} 
     setbudgetoverlay={setbudgetoverlay} 
     fy_list={fy_list} 
     formatNumber={formatNumber}
     storedGlobalDateId={storedGlobalDateId}
     filterPayload={filterPayload} 
     handleYearDropdown={handleYearDropdown}/>

      {/* =====================scheme balance overlay========================== */}

    <SchemeBalance
      dividerNumber={dividerNumber}
      schemebalance={schemebalance}
      formatNumber={formatNumber}
      setSchemebalance={setSchemebalance}
      addElipsis={addElipsis}
      fy_list={fy_list}
      filterPayload={filterPayload}
      // schemes={schemes}
    ></SchemeBalance>

      {/* =====================bank balance overlay========================== */}

    <BankBalanceOverlay
      openOverlay={bankBalanceOverlay}
      bankBalanceOverlays={setBankBalanceOverlay}
      fetchBankBalance={fetchBankBalance}
      fy_list={fy_list}
      filterPayload={filterPayload}
    />

      {/* ======================approvals overlay=========================== */}

    <div className={`overlay  ${approvalsOverlay ? "d-none" : null}  `}></div>
    <ApprovalOverlay 
      approvalsOverlay={approvalsOverlay}
      storedGlobalDateId={storedGlobalDateId}
      addElipsis={addElipsis}
      fy_list={fy_list} 
      setWithHeldAndPenalty={setWithHeldAndPenalty}
      formatNumber={formatNumber}
      dividerNumber={dividerNumber}
      handleYearDropdown={handleYearDropdown}
      setApprovalsOverlay={setApprovalsOverlay}
      invoices={invoices}
      filterPayload={filterPayload}
    />

      {/* ======================Accumulation overlay =========================== */}

      <div
        className={`overlay  ${
          accumulatedDeductionOverlay ? "d-none" : null
        }  `}
      ></div>

      <div
        className={`overlayContent overflow-x-hidden overflow-y-auto ${
          accumulatedDeductionOverlay ? "left-100" : null
        } `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-secondary-100 position-relative text-white d-flex justify-content-between align-items-center p-3 position-sticky top-0 z-3">
          <div className="fw-600 fs-16px d-flex align-items-center gap-1 ">
            <i
              className="icon-close_circle_fill fs-5  cursor-pointer"
              onClick={() => setAccumulatedDeductionOverlay(true)}
            ></i>
            Accumulated Deduction - FY
            <select
              name="financial_year_id"
              onChange={handleYearDropdown}
              className="bg-transparent border-0 text-white fw-500 fs-16px select"
              disabled
            >
              <option value="" className="text-black">
                select year
              </option>
              {fy_list?.map((fy) => {
                return (
                  <option
                    value={storedGlobalDateId}
                    key={fy.id}
                    className="text-black"
                    selected={
                      String(fy.id) === storedGlobalDateId ||
                      (!storedGlobalDateId &&
                        fy.start_year === moment().format("YYYY"))
                    }
                  >
                    {fy.year}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="d-flex gap-2 align-items-center ">
            <span>
              As on date{" "}
              {
                <select
                  name="financial_year_id"
                  className="bg-transparent border-0 text-white fw-500 fs-16px select"
                  disabled
                >
                  <option value="" className="text-black">
                    select year
                  </option>
                  {fy_list?.map((fy) => {
                    return (
                      <option
                        value={storedGlobalDateId}
                        key={fy.id}
                        className="text-black"
                        selected={
                          String(fy.id) === storedGlobalDateId ||
                          (!storedGlobalDateId &&
                            fy.start_year === moment().format("YYYY"))
                        }
                      >
                        {fy.start_year.includes(new Date().getFullYear())
                          ? moment().format("Do MMM YYYY")
                          : "31 Mar " + fy.end_year}
                      </option>
                    );
                  })}
                </select>
              }
            </span>
            <i
              className="icon-arrow_drop_down_circle fs-18px cursor-pointer"
              onClick={() => setOverlayDropDown((prev) => !prev)}
            ></i>

            <div
              className={`position-absolute bg-prime-100 w-100 p-3 ${
                !overlayDropDown ? "d-none" : "d-inline-block"
              }`}
              style={{ top: "100%", zIndex: "10" }}
            >
              <div className="d-flex flex-column gap-4">
                <span className="d-flex align-items-center gap-2">
                  {" "}
                  <i className="icon-featured_play_list"></i> Export Excel
                </span>
                <span className="d-flex align-items-center gap-2">
                  {" "}
                  <i className="icon-picture_as_pdf"></i> Export PDF
                </span>
                <span className="d-flex align-items-center gap-2">
                  {" "}
                  <i className="icon-view_list"></i> List View
                </span>
                <span className="d-flex align-items-center gap-2">
                  {" "}
                  <i className="icon-grid_on"></i> Grid View
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="px-4 py-3 d-flex flex-column gap-2">
          {/* =============================vendor card==================== */}

          <div
            className="bg-white border-Prime-100"
            style={{ borderRadius: "8px" }}
            // key={val?.id}
          >
            <div
              className="bg-prime-20 d-flex justify-content-between align-items-center py-2 transition overflow-hidden px-3"
              style={{ borderRadius: "8px 8px 0 0" }}
            >
              {/* ======================card header================== */}
              <span
                className="fs-14px white-space-nowrap overflow-x-hidden"
                style={{ width: "95%", fontStyle: "italic" }}
              >
                {/* =======================card header====================== */}
                <span
                  className="fs-14px white-space-nowrap overflow-x-hidden "
                  style={{ width: "95%", fontStyle: "italic" }}
                >
                  <span className="fw-500 text-secondary-100">Vendor</span>
                </span>
              </span>

              <span>
                <i className="icon-filter_alt cursor-pointer p-2 transition bg-active-prime-100 rounded-2"></i>
              </span>
            </div>

            {/* ================== card body ========================= */}

            <div className="row py-2 px-3">
              <div className="row">
                <div className="col-2 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Total TDS IT</span>
                  <span className="fw-500 fs-14px">
                    {totalTdsIt == 0
                      ? "-"
                      : formatNumber(totalTdsIt / dividerNumber, "indian")}
                  </span>
                </div>
                <div className="col-2 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Total TDS GST</span>
                  <span className="fw-500 fs-14px">
                    {totalaccTotalTdsGst == 0
                      ? "-"
                      : formatNumber(
                          totalaccTotalTdsGst / dividerNumber,
                          "indian"
                        )}
                  </span>
                </div>
                <div className="col-2 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Total Royalty</span>
                  <span className="fw-500 fs-14px">
                    {totalRoyalty == 0
                      ? "-"
                      : formatNumber(totalRoyalty / dividerNumber, "indian")}
                  </span>
                </div>
                <div className="col-2 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">
                    Total Labour Cess
                  </span>
                  <span className="fw-500 fs-14px">
                    {totalacclaboutCess == 0
                      ? "-"
                      : formatNumber(
                          totalacclaboutCess / dividerNumber,
                          "indian"
                        )}
                  </span>
                </div>
                <div className="col-2 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Total Other</span>
                  <span className="fw-500 fs-14px">
                    {totalaccOther == 0
                      ? "-"
                      : formatNumber(totalaccOther / dividerNumber, "indian")}
                  </span>
                </div>
                <div className="col-2 d-flex flex-column bg-success-20 py-2">
                  <span className="text-black-60 fs-12px d-flex justify-content-between align-items-center">
                    Total Deducation
                    <span>
                      <i className="icon-info cursor-pointer"></i>
                    </span>
                  </span>
                  <span className="fw-500 fs-14px">
                    {totalTdsIt +
                      totalaccTotalTdsGst +
                      totalRoyalty +
                      totalacclaboutCess +
                      totalaccOther ==
                    0
                      ? "-"
                      : formatNumber(
                          (totalTdsIt +
                            totalaccTotalTdsGst +
                            totalRoyalty +
                            totalacclaboutCess +
                            totalaccOther) /
                            dividerNumber,
                          "indian"
                        )}
                  </span>
                </div>
              </div>
            </div>
            <div className="px-3 pb-2">
              <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="0"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("0")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>Deduction Details</span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("0") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div
                      className="row fs-12px text-black-60 p-1 mt-1 m-auto"
                      style={{ width: "99%" }}
                    >
                      <div
                        className="col text-start p-0"
                        style={{ width: "20%" }}
                      >
                        vendor
                      </div>
                      <div
                        className="col text-start p-0"
                        style={{ width: "20%" }}
                      >
                        Invoice No/Date
                      </div>
                      <div
                        className="col text-start p-0"
                        style={{ width: "20%" }}
                      >
                        TDS IT
                      </div>
                      <div
                        className="col text-start p-0"
                        style={{ width: "20%" }}
                      >
                        Total TDS GST
                      </div>
                      <div
                        className="col text-start p-0"
                        style={{ width: "20%" }}
                      >
                        Royalty
                      </div>
                      <div
                        className="col text-start p-0"
                        style={{ width: "20%" }}
                      >
                        Labour Cess
                      </div>
                      <div
                        className="col text-start p-0"
                        style={{ width: "20%" }}
                      >
                        Other
                      </div>
                      <div
                        className="col text-start p-0"
                        style={{ width: "20%" }}
                      >
                        Total
                      </div>
                    </div>
                    <div
                      className="overflow-x-hidden overflow-y-auto ps-3"
                      style={{ maxHeight: "200px", height: "auto" }}
                    >
                      {/* ==============================subhead data================================ */}

                      {accumulationVendorData?.map((val, ind) => (
                        <div
                          className="row fs-14px p-1 fw-500 overflow-hidden"
                          style={{
                            background:
                              ind % 2 === 0 ? "#F8F8F8" : "transparent",
                          }}
                        >
                          <div className="col p-0" style={{ width: "20%" }}>
                            {val?.company_name}
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            {addElipsis(
                              val?.invoice_no + " | " + val?.invoice_date,
                              13
                            )}
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            {val?.tds_it_amount == 0
                              ? "-"
                              : formatNumber(
                                  val?.tds_it_amount / dividerNumber,
                                  "indian"
                                )}
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            {Number(val?.c_gst_amount) +
                              Number(val?.i_gst_amount) +
                              Number(val?.s_gst_amount) ==
                            0
                              ? "-"
                              : formatNumber(
                                  (Number(val?.c_gst_amount) +
                                    Number(val?.i_gst_amount) +
                                    Number(val?.s_gst_amount)) /
                                    dividerNumber,
                                  "indian"
                                )}
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            {val?.royalty_amount == 0
                              ? "-"
                              : formatNumber(
                                  val?.royalty_amount / dividerNumber,
                                  "indian"
                                )}
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            {val?.labour_amount == 0
                              ? "-"
                              : formatNumber(
                                  val?.labour_amount / dividerNumber,
                                  "indian"
                                )}
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            {val?.other_deduction == null
                              ? "-"
                              : val?.other_deduction == 0
                              ? "-"
                              : formatNumber(
                                  val?.other_deduction / dividerNumber,
                                  "indian"
                                )}
                          </div>
                          <div
                            className="col p-0 text-success-100"
                            style={{ width: "20%" }}
                          >
                            {Number(val?.tds_it_amount) +
                              Number(val?.c_gst_amount) +
                              Number(val?.i_gst_amount) +
                              Number(val?.s_gst_amount) +
                              Number(val?.royalty_amount) +
                              Number(val?.labour_amount) +
                              Number(
                                val?.other_deduction == null
                                  ? 0
                                  : val?.other_deduction
                              ) ==
                            0
                              ? "-"
                              : formatNumber(
                                  (Number(val?.tds_it_amount) +
                                    Number(val?.c_gst_amount) +
                                    Number(val?.i_gst_amount) +
                                    Number(val?.s_gst_amount) +
                                    Number(val?.royalty_amount) +
                                    Number(val?.labour_amount) +
                                    Number(
                                      val?.other_deduction == null
                                        ? 0
                                        : val?.other_deduction
                                    )) /
                                    dividerNumber,
                                  "indian"
                                )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>

          {/* ===========================DBT card=========================== */}

          <div
            className="bg-white border-Prime-100"
            style={{ borderRadius: "8px" }}
            // key={val?.id}
          >
            <div
              className="bg-prime-20 d-flex justify-content-between align-items-center py-2 transition overflow-hidden px-3"
              style={{ borderRadius: "8px 8px 0 0" }}
            >
              {/* ======================card header================== */}
              <span
                className="fs-14px white-space-nowrap overflow-x-hidden"
                style={{ width: "95%", fontStyle: "italic" }}
              >
                {/* =======================card header====================== */}
                <span
                  className="fs-14px white-space-nowrap overflow-x-hidden "
                  style={{ width: "95%", fontStyle: "italic" }}
                >
                  <span className="fw-500 text-secondary-100">DBT/NACH</span>
                </span>
              </span>

              <span>
                <i className="icon-filter_alt cursor-pointer p-2 transition bg-active-prime-100 rounded-2"></i>
              </span>
            </div>

            {/* ================== card body ========================= */}

            <div className="row py-2 px-3">
              <div className="row">
                <div className="col-4 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Gross Amount</span>
                  <span className="fw-500 fs-14px">
                    {totalGrossAmount == 0
                      ? "-"
                      : formatNumber(
                          totalGrossAmount / dividerNumber,
                          "indian"
                        )}
                  </span>
                </div>
                <div className="col-4 d-flex flex-column bg-success-20 py-2">
                  <span className="text-black-60 fs-12px">
                    Deduction Amount
                  </span>
                  <span className="fw-500 fs-14px text-success-100">
                    {totalDeductions == 0
                      ? "-"
                      : formatNumber(totalDeductions / dividerNumber, "indian")}
                  </span>
                </div>
                <div className="col-4 d-flex flex-column  py-2">
                  <span className="text-black-60 fs-12px">Net Amount </span>
                  <span className="fw-500 fs-14px">
                    {totalGrossAmount - totalDeductions == 0
                      ? "-"
                      : formatNumber(
                          (totalGrossAmount - totalDeductions) / dividerNumber,
                          "indian"
                        )}
                  </span>
                </div>
              </div>
            </div>

            <div className="px-3 pb-2">
              <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="9"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("9")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>Order Details</span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("9") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div>
                      {/* ==============================subhead data================================ */}

                      <div className="row fs-12px text-black-60 p-1 mt-1">
                        <div
                          className="col text-start px-0"
                          style={{ width: "20%" }}
                        >
                          Department Level/Name
                        </div>
                        <div
                          className="col text-start px-0"
                          style={{ width: "20%" }}
                        >
                          Order No./Date
                        </div>
                        <div
                          className="col text-start px-0"
                          style={{ width: "20%" }}
                        >
                          Scheme/Subhead Code
                        </div>
                        <div
                          className="col text-start px-0"
                          style={{ width: "20%" }}
                        >
                          Gross Amount
                        </div>
                        <div
                          className="col text-start px-0"
                          style={{ width: "20%" }}
                        >
                          Deduction
                        </div>
                        <div
                          className="col text-start px-0"
                          style={{ width: "20%" }}
                        >
                          Net Amount
                        </div>
                      </div>

                      {accumulationDBTData?.map((val, ind) => (
                        <div
                          className="row fs-14px p-1 fw-500 overflow-hidden"
                          style={{
                            height: !subheadAccordingdbtAcd[ind]
                              ? "35px"
                              : "fit-content",
                          }}
                          onClick={() =>
                            getSingleBeneficiaryReimbursements(val?.id)
                          }
                        >
                          <div
                            className="row fs-14px p-1 fw-500"
                            style={{
                              background:
                                ind % 2 === 0 ? "#F8F8F8" : "transparent",
                            }}
                          >
                            <div
                              className="col d-flex align-items-center"
                              style={{ widows: "20%" }}
                            >
                              {subheadAccordingdbtAcd ? (
                                <i
                                  className="icon-keyboard_arrow_right cursor-pointer"
                                  onClick={() => toggleAccordionacd(ind)}
                                ></i>
                              ) : (
                                <i
                                  className="icon-keyboard_arrow_down cursor-pointer"
                                  onClick={() => toggleAccordionacd(ind)}
                                ></i>
                              )}
                              <span>
                                {" "}
                                {addElipsis(
                                  val?.department_level +
                                    " | " +
                                    val?.department,
                                  13
                                )}
                              </span>
                            </div>

                            <div className="col" style={{ width: "20%" }}>
                              {addElipsis(
                                val?.reimbursement_order_no +
                                  " | " +
                                  val?.reimbursement_order_date,
                                13
                              )}
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                              {addElipsis(
                                val?.code + " | " + val?.subhead_code,
                                13
                              )}
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                              {val?.reimbursement_order_value == 0
                                ? "-"
                                : formatNumber(
                                    val?.reimbursement_order_value /
                                      dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                              {val?.deduction_amount == 0
                                ? "-"
                                : formatNumber(
                                    val?.deduction_amount / dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                              {Number(val?.reimbursement_order_value) -
                                Number(val?.deduction_amount) ==
                              0
                                ? "-"
                                : formatNumber(
                                    (Number(val?.reimbursement_order_value) -
                                      Number(val?.deduction_amount)) /
                                      dividerNumber,
                                    "indian"
                                  )}
                            </div>
                          </div>

                          <div className="mt-1 p-0 pe-3">
                            <table className="border-0">
                              <tr className="bg-prime-20 border-0">
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  Name
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  Mobile/Email
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  IFSC
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  Gross Amount
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  Deduction
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  Net Amount
                                </th>
                              </tr>
                              {singleBeneficiarys?.map((val, ind) => (
                                <tr>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {val?.name}
                                  </td>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {val?.mobile} | {val?.email}
                                  </td>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {val?.ifsc}
                                  </td>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {val?.gross_amount}
                                  </td>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {val?.deduction_amount}
                                  </td>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {Number(val?.gross_amount) -
                                      Number(val?.deduction_amount)}
                                  </td>
                                </tr>
                              ))}
                            </table>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>

          {/* =================salery card========================= */}

          <div
            className="bg-white border-Prime-100"
            style={{ borderRadius: "8px" }}
            // key={val?.id}
          >
            <div
              className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden px-3"
              style={{ borderRadius: "8px 8px 0 0" }}
            >
              {/* ======================card header================== */}
              <span
                className="fs-14px white-space-nowrap overflow-x-hidden"
                style={{ width: "95%", fontStyle: "italic" }}
              >
                {/* =======================card header====================== */}
                <span
                  className="fs-14px white-space-nowrap overflow-x-hidden "
                  style={{ width: "95%", fontStyle: "italic" }}
                >
                  <span className="fw-500 text-secondary-100">Salary</span>
                </span>
              </span>

              <span>
                <i className="icon-filter_alt cursor-pointer p-2 transition bg-active-prime-100 rounded-2"></i>
              </span>
            </div>

            {/* ================== card body ========================= */}

            <div className="row py-2 px-3">
              <div className="row">
                <div className="col-2 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Total TDS IT</span>
                  <span className="fw-500 fs-14px">2,000,000,000.00</span>
                </div>
                <div className="col-2 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Total TDS GST</span>
                  <span className="fw-500 fs-14px">2,000,000,000.00</span>
                </div>
                <div className="col-2 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Total Royalty</span>
                  <span className="fw-500 fs-14px">2,000,000,000.00</span>
                </div>
                <div className="col-2 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">
                    Total Labour Cess
                  </span>
                  <span className="fw-500 fs-14px">2,000,000,000.00</span>
                </div>
                <div className="col-2 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Total Other</span>
                  <span className="fw-500 fs-14px">2,000,000,000.00</span>
                </div>
                <div className="col-2 d-flex flex-column bg-success-20 py-2">
                  <span className="text-black-60 fs-12px d-flex justify-content-between align-items-center">
                    Total Deducation
                    <span>
                      <i className="icon-info cursor-pointer"></i>
                    </span>
                  </span>
                  <span className="fw-500 fs-14px">2,000,000,000.00</span>
                </div>
              </div>
            </div>
            <div className="px-3 pb-2">
              <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="10"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("10")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>Deduction Details</span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("10") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div>
                      {/* ==============================subhead data================================ */}
                      <p>this is pending design</p>

                      <div className="row fs-12px text-black-60 p-1 mt-1">
                        <div
                          className="col text-start px-0"
                          style={{ width: "20%" }}
                        >
                          vendor
                        </div>
                        <div
                          className="col text-start px-0"
                          style={{ width: "20%" }}
                        >
                          Invoice No/Date
                        </div>
                        <div
                          className="col text-start px-0"
                          style={{ width: "20%" }}
                        >
                          sanction Order/Date
                        </div>
                        <div
                          className="col text-start px-0"
                          style={{ width: "20%" }}
                        >
                          Amount
                        </div>
                        <div
                          className="col text-start px-0"
                          style={{ width: "20%" }}
                        >
                          Action
                        </div>
                      </div>

                      <div
                        className="row fs-14px p-1 fw-500 overflow-hidden"
                        style={{
                          height: subheadAccording ? "35px" : "fit-content",
                        }}
                      >
                        <div
                          className="row fs-14px p-1 fw-500"
                          style={{ background: "#F8F8F8" }}
                        >
                          <div
                            className="col d-flex align-items-center"
                            style={{ widows: "20%" }}
                          >
                            {subheadAccording ? (
                              <i
                                className="icon-keyboard_arrow_right cursor-pointer"
                                onClick={() =>
                                  setSubheadAccording((prev) => !prev)
                                }
                              ></i>
                            ) : (
                              <i
                                className="icon-keyboard_arrow_down cursor-pointer"
                                onClick={() =>
                                  setSubheadAccording((prev) => !prev)
                                }
                              ></i>
                            )}
                            <span>radhe krishna</span>
                          </div>

                          <div className="col" style={{ width: "20%" }}>
                            25412 | 10/08/2025
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            25412 | 10/08/2025
                          </div>
                          <div
                            className="col text-success-100"
                            style={{ width: "20%" }}
                          >
                            2,000,000,000.00
                          </div>
                        </div>

                        <div className="mt-1 p-0 pe-3">
                          <table className="border-0">
                            <tr className="bg-prime-20 border-0">
                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                Name
                              </th>
                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                Mobile/Email
                              </th>
                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                Action/IFSC
                              </th>
                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                Gross Amount
                              </th>
                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                Deduction
                              </th>
                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                Net Amount
                              </th>
                            </tr>
                            <tr>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                radha krishna
                              </td>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                123456780
                              </td>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                123456780
                              </td>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                123456780
                              </td>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                123456780
                              </td>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                123456780
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
          
        </div>
      </div>

      {/* ======================Reconciliation overlay=========================== */}

      <ReconciliationOverlay 
        reconciliationOverlay={reconciliationOverlay}
        setReconciliationOverlay={setReconciliationOverlay}
        fy_list={fy_list}
        storedGlobalDateId={storedGlobalDateId}
        formatNumber={formatNumber}
        dividerNumber={dividerNumber}
        handleYearDropdown={handleYearDropdown}
        addElipsis={addElipsis}
        accumulatedDeductionDbt={accumulatedDeductionDbt}
        accumulatedDeduction={accumulatedDeduction}
        totalTdsIts={totalTdsIts}
        totalGst={totalGst}
        totalRoyaltys={totalRoyaltys}
        totalLabour={totalLabour}
        getSingleBeneficiaryReimbursements={getSingleBeneficiaryReimbursements}
        totalOtherDeduction={totalOtherDeduction}
        singleBeneficiarys={singleBeneficiarys}
        settlementsInProgress={settlementsInProgress}
        totalPenalty={totalPenalty}
        totalWithheld={totalWithheld}
        totalOverall={totalOverall}
        withHeldAndPenalty={withHeldAndPenalty}
        totalOverallAccDeduction={totalOverallAccDeduction}
        totalReimbursementOrderValue={totalReimbursementOrderValue}
      />



    </>
  );
};

export default DashboardBox;
